import React, { useRef } from 'react';
import styled from 'styled-components';
import { useClickOutside } from '../../hooks/useClickOutside';
import { SAVE_SORT_OPTIONS } from '../../constants/saveConstants';

const DropdownContainer = styled.div`
    position: absolute;
    top: 40px; /* Position below the search bar */
    right: 0;
    background: #282E33;
    border-radius: 4px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    z-index: 100;
    width: 200px;
    padding: 8px;
`;

const DropdownOption = styled.div`
    padding: 8px 12px;
    color: #B6C2CF;
    cursor: pointer;
    font-size: 14px;
    border-radius: 3px;

    &:hover {
        background-color: #3B444C;
    }

    &.active {
        background-color: #007bff;
        color: white;
    }
`;

const SortDropdownMenu = ({ isOpen, onClose, setSortBy, currentSort }) => {
    const dropdownRef = useRef(null);
    useClickOutside(dropdownRef, onClose);

    if (!isOpen) {
        return null;
    }

    const handleSortChange = (sortOption) => {
        setSortBy(sortOption);
        onClose();
    };

    return (
        <DropdownContainer ref={dropdownRef}>
            <DropdownOption
                className={currentSort === SAVE_SORT_OPTIONS.RECENT ? 'active' : ''}
                onClick={() => handleSortChange(SAVE_SORT_OPTIONS.RECENT)}
            >
                Recent
            </DropdownOption>
            <DropdownOption
                className={currentSort === SAVE_SORT_OPTIONS.OLDEST ? 'active' : ''}
                onClick={() => handleSortChange(SAVE_SORT_OPTIONS.OLDEST)}
            >
                Oldest
            </DropdownOption>
            <DropdownOption
                className={currentSort === SAVE_SORT_OPTIONS.ALPHA_ASC ? 'active' : ''}
                onClick={() => handleSortChange(SAVE_SORT_OPTIONS.ALPHA_ASC)}
            >
                Alphabetical (A-Z)
            </DropdownOption>
            <DropdownOption
                className={currentSort === SAVE_SORT_OPTIONS.ALPHA_DESC ? 'active' : ''}
                onClick={() => handleSortChange(SAVE_SORT_OPTIONS.ALPHA_DESC)}
            >
                Alphabetical (Z-A)
            </DropdownOption>
        </DropdownContainer>
    );
};

export default SortDropdownMenu;
